import { Fragment } from 'react';
import { Grid } from '@mui/material';

import MuiTable from './MuiTable';
import { IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../components/SectionTitle';
import useTableForm from '../hooks/useTableForm';

interface Props extends IFormValues, IFormWatch {
  disabled?: boolean;
}

const BodyStatus = (props: Props) => {
  const { radioGroup } = useTableForm(props);

  const columns = [
    { fieldId: 'title', label: 'Tình trạng thể chất' },
    {
      fieldId: '0',
      label: 'Trợ giúp hoàn toàn',
      sx: { textAlign: 'center' },
    },
    { fieldId: '1', label: 'Trợ giúp một phần', sx: { textAlign: 'center' } },
    {
      fieldId: '2',
      label: 'Hoàn toàn tự lập',
      sx: { textAlign: 'center' },
    },
  ];

  const rows = [
    {
      id: 'takeOffClothes',
      title: 'Thay đồ',
      ...radioGroup({
        key: 'body_status.takeOffClothes',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'eat',
      title: 'Ăn uống',
      ...radioGroup({
        key: 'body_status.eat',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'sitUp',
      title: 'Ngồi',
      ...radioGroup({
        key: 'body_status.sitUp',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'toilet',
      title: 'Sử dụng nhà vệ sinh',
      ...radioGroup({
        key: 'body_status.toilet',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'washFace',
      title: 'Rửa mặt',
      ...radioGroup({
        key: 'body_status.washFace',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'bath',
      title: 'Tắm',
      ...radioGroup({
        key: 'body_status.bath',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'transfer',
      title: 'Thay dổi vị trí ngồi',
      ...radioGroup({
        key: 'body_status.transfer',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'controlStool',
      title: 'Kiểm soát điều tiết phân',
      ...radioGroup({
        key: 'body_status.controlStool',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'brushTeeth',
      title: 'Đánh răng',
      ...radioGroup({
        key: 'body_status.brushTeeth',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'changePosition',
      title: 'Thay đổi tư thế',
      ...radioGroup({
        key: 'body_status.changePosition',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'getOutRoom',
      title: 'Ra khỏi phòng',
      ...radioGroup({
        key: 'body_status.getOutRoom',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
    {
      id: 'controlUrine',
      title: 'Kiểm soát điều tiết nước tiểu',
      ...radioGroup({
        key: 'body_status.controlUrine',
        options: [1, 2, 3],
        width: '25px',
      }),
    },
  ];

  return (
    <Fragment>
      <SectionTitle title="Tình trạng thể chất (Khả năng thực hiện các hoạt động hàng ngày)" />
      <Grid item xs={12}>
        <MuiTable columns={columns} rows={rows} />
      </Grid>
    </Fragment>
  );
};

export default BodyStatus;
